if (!window.__calmiluneBuyNowBound) {
  window.__calmiluneBuyNowBound = true;

  document.addEventListener('click', async (event) => {
    const offer = event.target.closest('[data-calmilune-offer]');

    if (offer) {
      const selector = offer.closest('[data-calmilune-offer-selector]');
      const form = offer.closest('form');
      if (!selector || !form) return;

      selector.querySelectorAll('[data-calmilune-offer]').forEach((item) => {
        item.setAttribute('aria-pressed', item === offer ? 'true' : 'false');
      });

      const quantityInput = form.querySelector('[data-calmilune-quantity]');
      if (quantityInput) {
        quantityInput.value = offer.dataset.quantity || '1';
      }

      const buyButton = form.querySelector('[data-calmilune-buy-now]');
      if (buyButton) {
        buyButton.textContent = offer.dataset.cta || 'Acheter maintenant';
      }

      return;
    }

    const button = event.target.closest('[data-calmilune-buy-now]');
    if (!button || button.disabled) return;

    const form = button.closest('form');
    if (!form) return;

    const selectedOffer = form.querySelector('[data-calmilune-offer][aria-pressed="true"]');
    const originalText = selectedOffer?.dataset.cta || button.textContent;
    const cartAddUrl = button.dataset.cartAddUrl || '/cart/add.js';
    const checkoutUrl = button.dataset.checkoutUrl || '/checkout';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Chargement…';

    try {
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { Accept: 'application/json' }
      });

      if (!clearResponse.ok) {
        throw new Error('Unable to clear cart');
      }

      const formData = new FormData(form);
      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });

      if (!response.ok) {
        throw new Error('Unable to add product');
      }

      window.location.assign(checkoutUrl);
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = originalText;

      const component = button.closest('product-form-component');
      const liveRegion = component?.querySelector('[ref="liveRegion"]');
      if (liveRegion) {
        liveRegion.textContent = 'Impossible de continuer vers le paiement. Veuillez réessayer.';
      }
    }
  });
}
